'use strict';

export default function () {
    return {
        restrict: 'A',
        template: require('../view/simple-metric.html'),
        scope: {
            value: '=value',
            unit: '=unit',
            name: '=name',
        },
        controller: [() => {
        }],
    };
}
